import { SERVICE_IDENTIFIER } from '@config/service-identifier';
import { container } from '@config/ioc.config';
var App = /** @class */ (function () {
    function App() {
        var _this = this;
        this.animate = function () {
            var _a, _b;
            if (_this._microphoneService.initialized) {
                (_a = _this._configuratorService.canvasContext) === null || _a === void 0 ? void 0 : _a.clearRect(0, 0, _this._configuratorService.width, _this._configuratorService.height);
                _this.rotateAnimation();
                _this._barsService.drawBars();
                (_b = _this._configuratorService.canvasContext) === null || _b === void 0 ? void 0 : _b.restore();
            }
            requestAnimationFrame(_this.animate);
        };
        this._configuratorService = container.get(SERVICE_IDENTIFIER.CONFIGURATOR_SERVICE);
        this._microphoneService = container.get(SERVICE_IDENTIFIER.MICROPHONE_SERVICE);
        this._barsService = container.get(SERVICE_IDENTIFIER.BARS_SERVICE);
        this._angle = 0;
        this.animate();
    }
    App.prototype.rotateAnimation = function () {
        var _a, _b, _c;
        this._angle -= 0.01;
        (_a = this._configuratorService.canvasContext) === null || _a === void 0 ? void 0 : _a.save();
        (_b = this._configuratorService.canvasContext) === null || _b === void 0 ? void 0 : _b.translate(this._configuratorService.width / 2, this._configuratorService.height / 2);
        (_c = this._configuratorService.canvasContext) === null || _c === void 0 ? void 0 : _c.rotate(this._angle);
    };
    return App;
}());
export { App };
